import { SearchConditionsParams, SearchConditionsResponse } from '@/component/FilterCommon/hooks/useSearchCondition';
import { axiosHttp } from '@/utils/http';
import { httpPc } from '@/utils/httpPc';

export const serviceSearchConditions =  async <T extends SearchConditionsParams>(params: T,) => {
  let res = await httpPc.get<AxiosHttpPromise<SearchConditionsResponse<T>>>('Api/v1/search/conditions', { params });
  return res
};

interface StaffParams {
  page: number; // 从0开始
  pageSize: number; //10
  isCustomize: boolean; //true
  staff_type: 'salesman';
  kw?:string
}
export interface StaffItem {
  staff_id: string; //"53289",
  staff_num: string; //"",
  staff_name: string; //"\u6d4b\u8bd5",
  mobile: string; //"18782900111",
  branch_num: string; //"",
  branch_name: string; //"",
  accounts_name: string; //"yang-ceshi"
}

export interface GoodsListParams  {
  page: number; // 从0开始
  pageSize: number; //10
  isCustomize: boolean; //true
  source_company_id?: number, //运营公司id,联营端才传
  collaborator_id?: number //联营公司id,联营端才传
}

export interface GoodsItem {
  goods_id: string;
  goods_num: string;
  goods_name: string;
  goods_picture: string;
  base_units: string;
  brand_id: string;
  container_units: string;
  purchase_price: string;
  whole_price: string;
  conversion_number: string;
  price_count: string;
  multi_id: string;
  base2middle_unit_rate: string;
  middle_units: string;
  putaway: string;
  selling_price: string;
  goods_weight: string;
  base_client_id: string;
  min_order: string;
  order_units: string;
  settle_price: string;
  goods_model: string;
  base_barcode: string;
  middle_barcode: string;
  conversion_barcode: string;
  goods_allocation: string;
  translation: string;
  field_1: string;
  field_2: string;
  field_3: string;
  field_4: string;
  field_5: string;
  field_6: string;
  split_type: string;
  price_id: number;
  brand_name: string | null;
  available_number: string;
  real_number: string;
  help_units: string;
  split_type_name: string;
  client_name: string | null;
}

export const serviceStaffs = (params: Partial<StaffParams>,)=> {
  params.page = (params.page || 1) - 1;
  return axiosHttp.get<'',AxiosHttpPromise<{ count: number; list: StaffItem[] }> >('/Api/v1/staffs/dialogLists', { params }) ;
};

// export const serviceConditions = ()=>{
//   return axiosHttp.get('Api/v1/search/conditions') ;
// }

export const serviceGoodsList = (params:Partial<GoodsListParams>)=>{
  params.page = (params.page || 1) - 1;
  return axiosHttp.get<'', AxiosHttpPromise<{ count: number; list: GoodsItem[] }>>('Api/v1/goods/dialogLists',{params });
}
// Api/v1/suppliers/dialogLists
export const serviceSuppliers = (params:Partial<{
  kw?: string;
  base_client_id: string,
  page: number // 0,
  pageSize:  number // 10
}>)=>{
  params.page = (params.page || 1) - 1;
  return httpPc.get< AxiosHttpPromise<{ count: number; list: Array<{
    address: string;
    base_client_id: string;
    city_id: string;
    client_id: string;
    client_name: string;
    client_num: string;
    contact: string;
    email: string;
    mobile: string;
    phone: string;
    remark: string;
  }>}>>('Api/v1/suppliers/dialogLists',{params });
}

type ClientParams = {

  page: number,
  pageSize: number

}
export type ClientResonse = {
  "status": string // "T",
  "data": {
    "list": [
      {
        "base_client_id": string // "30442",
        "company_id": string // "311",
        "client_id": string // "37310",
        "client_type": string // "agency",
        "type_id": string // "1400",
        "area_id": string // "837",
        "status": string // "T",
        "client_num": string // "24566",
        "client_name": string // "测试编号1",
        "pinyin": string // "csbh1",
        "contact": string // "李先生",
        "remark": string // "",
        "clearing_form": string // "postpaid",
        "clearing_date": string // "0",
        "balance": string // "329.0000",
        "rebate_amount": string // "0.0000",
        "credit": string // "0.0000",
        "custom_data": string // "\"\"",
        "update_date": string // "2024-08-24 15:18:53",
        "create_date": string // "2019-02-27 16:18:55",
        "phone": string // "13183873888",
        "city_id": string // "0",
        "address": string // "四川省成都市天府三街",
        "email": string // "329032@qq.com",
        "mobile": string // "18676765653",
        "regist_type": string // "F",
        "invite_code": string // "",
        "last_order_at": string // "2024-08-24 15:18:53",
        "staff_id": string // "53780",
        "last_visit_id": string // "0",
        "longitude": string // "0",
        "latitude": string // "0",
        "credit_status": string // "nonactivated",
        "credit_limit": string // "0.0000",
        "bill_date": string // "0",
        "repayment_date": string // "0",
        "credit_balance": string // "0.0000",
        "overdue_times": string // "0",
        "can_use_credit": string // "1",
        "last_login_date": string // "2024-05-13 15:34:59",
        "login_count": string // "10",
        "first_login_date": string // "2024-05-11 16:54:05",
        "first_login_device": string // "",
        "rebate_amount_version": string // "0",
        "pay_type": string // "0",
        "supplier_company_id": string // "0",
        "type_name": string // "默认",
        "area_name": string // "成都",
        "payment_account": []
      }
    ],
    "count": number // "215",
    "condition": {
      "kw": string // ""
    }
  },
  "code": number // 200
}

export const serviceClient = (params:Partial<ClientParams>)=>{
  let {  page = 1, pageSize = 10 } = params
  params.page = page -1
  params.pageSize = params.pageSize || pageSize
  return httpPc.get<ClientResonse>(`/Api/v1/client`,{params})
}